export default {
  // Common
  scroll: 'SCROLL',
  tax_included: '（税込）',
  tax_note: '税込',
  yen: '円',
  yen_suffix: '円',
  currency_suffix: '円',
  other_items: 'その他料理は店頭にてご確認ください',

  // Navbar
  nav_home: 'HOME',
  nav_menu: 'お品書き',
  nav_about: 'こだわり',
  nav_access: '店舗情報',
  nav_reservation: 'ご予約',
  nav_lang_ja: 'JAPANESE',
  nav_lang_en: 'ENGLISH',

  // Hero
  hero_subtitle: '匠の味',
  hero_title: '貴寿司',

  // Concept
  concept_label: 'CONCEPT',
  concept_title: '時を重ねた技がある。',
  concept_desc: '江戸前寿司の真髄は「仕事」にあり。最高級のシャリ、香り立つ海苔、熟成、〆、漬け——。ひと手間を惜しまず、素材の旨みを引き出す。職人の手仕事から生まれる、本物の一貫を\nお愉しみください。',
  concept_jcb: 'JCB THE PREMIUM 掲載店',

  // Menu
  menu_label: 'MENU',
  menu_title: 'お品書き',
  lunch_title: 'LUNCH',
  lunch_time: '11:30 - 14:00 (L.O. 13:30)',
  lunch_barachirashi: 'ばらちらし',
  lunch_barachirashi_price: '1500',
  lunch_tekkadon: '鉄火丼',
  lunch_tekkadon_price: '2000',
  course_title: 'コース料理',
  course_subtitle: '先付け・前菜・お造り・焼き魚（煮魚）・揚げ物（天ぷら）・\n寿司（握り又はちらし）・お椀　他',
  course_um: '梅',
  course_um_price: '7700',
  course_take: '竹',
  course_take_price: '11000',
  course_matsu: '松',
  course_matsu_price: '14300',
  nigiri_title: '握り',
  nigiri_subtitle: 'NIGIRI',
  nigiri_nami: '並',
  nigiri_nami_price: '3300',
  nigiri_jo: '上',
  nigiri_jo_price: '4400',
  nigiri_tokujo: '特上',
  nigiri_tokujo_price: '6600',
  nigiri_omakase: 'おまかせ',
  nigiri_omakase_price: '9900',
  maguro_title: 'まぐろ寿司',
  maguro_subtitle: 'MAGURO',
  maguro_tekkaju: '鉄火重',
  maguro_tekkaju_price: '3300',
  maguro_chutoroju: '中とろ重',
  maguro_chutoroju_price: '5500',
  maguro_akaminigiri: '赤身にぎり',
  maguro_akaminigiri_price: '3300',
  maguro_chutoronigiri: '中とろにぎり',
  maguro_chutoronigiri_price: '5500',
  sake_title: '日本酒',
  sake_subtitle: 'JAPANESE SAKE',
  sake_desc: '全国各地より、選りすぐりの地酒を取り揃えております。\n酒蔵から直接仕入れた、普段なかなかお目にかかれない銘柄もご用意。\n旬の寿司や料理とともに、ゆっくりとお愉しみください。',
  maki_title: '巻きもの',
  maki_subtitle: 'MAKIMONO',
  maki_items: 'のり巻,かっぱ巻,おしんこ巻,ごぼう巻,納豆巻,梅しそ巻,鉄火巻,とろ巻,ねぎとろ巻,とろたく巻,太巻,のり玉,お子様寿司',
  menu_reservation: 'ご予約はこちら',
  menu_phone: '03-3980-5537',
  menu_phone_note: '（定休日を除く）',

  // About / Kodawari
  about_label: 'こだわり',
  about_title: '江戸前寿司の真髄は「仕事」にあり。',
  about_subtitle: '伝統の技法と、旬の素材が織りなす味わいをご紹介します。',
  techniques_title: '伝統の技法と、旬の素材が織りなす味わいをご紹介します。',
  technique_shari_title: '最高級の銀シャリ',
  technique_shari_desc: '江戸前寿司の味わいを支える、まさに「命」ともいえるシャリ。貴寿司では、米一粒一粒が凛と立つよう、酢の合わせ加減にも細心の注意を払い、シャリそのものの旨みを引き出しています。',
  technique_jukusei_title: '熟成',
  technique_jukusei_desc: 'マグロをはじめとする魚介は、適切な温度と湿度のもとで熟成させることで、余分な水分が抜け、旨み成分であるイノシン酸が増加します。それぞれの魚の状態を見極め、最適な熟成期間でお出しします。',
  technique_shimeru_title: '〆る・漬ける',
  technique_shimeru_desc: '鯖や小肌は酢と塩で〆て旨みを凝縮。いくらは特製の醬油ダレに漬け込み、一粒一粒が宝石のような輝きを放ちます。先人たちが編み出した伝統技法を、現代の感覚で丁寧に受け継いでいます。',
  sourcing_title: '仕入れ・食材',
  sourcing_subtitle: 'SOURCING',
  sourcing_market_title: '毎朝の市場目利き',
  sourcing_market_desc: '豊洲市場に毎朝足を運び、その日の最高の魚を自らの目で見極めます。信頼する仲買人との長年の関係が、安定した品質の仕入れを支えています。',
  sourcing_season_title: '産地直送の旬',
  sourcing_season_desc: '北海道の雲丹、明石の鯛、対馬の穴子──。全国各地の生産者から直接届く、その季節ならではの逸品を。素材本来の持ち味を大切に、余計な手を加えすぎないこだわりがあります。',
  sourcing_condiments_title: '米・酢・醤油へのこだわり',
  sourcing_condiments_desc: '寿司の味を支える、シャリ・酢・醤油。\n米はふっくらと炊き上げた銀シャリに。\n酢と醤油にもこだわり、素材本来の旨みを引き立てます。',
  about_cta: 'ご予約はこちら',

  // Access
  access_label: 'ACCESS',
  access_title: '店舗情報・アクセス',
  info_title: '店舗基本情報',
  info_subtitle: 'INFORMATION',
  info_name: '店名',
  info_name_val: '貴寿司',
  info_address: '住所',
  info_address_val: '〒171-0022\n東京都豊島区南池袋２丁目９−１８',
  info_phone: '電話番号',
  info_phone_val: '03-3980-5537',
  info_hours: '営業時間',
  info_hours_val: '【昼】11:30 - 14:00（L.O. 13:30）\n【夜】17:00 - 22:00（L.O. 21:30）',
  info_closed: '定休日',
  info_closed_val: '月曜日',
  info_seats: '席数',
  info_seats_val: 'カウンター 8席 / 掘りごたつ式のお座敷 12席 / 2F お座敷 22席',
  info_payment: '支払方法',
  info_payment_val: '現金 / 各種クレジットカード（VISA, MasterCard, AMEX, JCB, Diners）',
  guidelines_title: 'ご利用にあたって',
  guidelines_subtitle: 'GUIDELINES',
  guideline_dress_title: 'ドレスコード',
  guideline_dress_desc: '特に御座いませんが、香水や強い香りの整髪料は、寿司の繊細な香りを損なう場合がございますので、控えめにお願いいたします。',
  guideline_time_title: 'お時間について',
  guideline_time_desc: 'ランチは90分、ディナーは120分を目安にお願いしております。\nコース料理の提供時間の都合上、ご予約時間から15分以上遅れられますと、一部お料理を省略させていただく場合がございます。',
  guideline_cancel_title: 'キャンセルポリシー',
  guideline_cancel_desc: 'ご予約のキャンセルは、前日50%、当日100%のキャンセル料を申し受けます。\nご変更は前日までにご連絡をお願いいたします。',
  guideline_allergy_title: 'アレルギー・苦手な食材について',
  guideline_allergy_desc: '当日の対応は難しい場合がございますため、ご予約時に必ずお申し付けください。\n可能な範囲で別の食材に変更いたします。',
  access_cta_text: 'アクセスについてのお問い合わせもお気軽に',
  access_reservation: 'ご予約はこちら',

  // StoreInfo (Home)
  storeinfo_label: 'INFORMATION',
  storeinfo_title: 'ご来店のご案内',
  storeinfo_hours: '営業時間',
  storeinfo_hours_lunch: '【昼】11:30 - 14:00',
  storeinfo_hours_lunch_lo: '（L.O. 13:30）',
  storeinfo_hours_dinner: '【夜】17:00 - 22:00',
  storeinfo_hours_dinner_lo: '（L.O. 21:30）',
  storeinfo_closed: '定休日：月曜日',
  storeinfo_access: 'アクセス',
  storeinfo_access_val: '〒171-0022\n東京都豊島区南池袋２丁目９−１８',
  storeinfo_contact: 'お問い合わせ',
  storeinfo_contact_phone: '03-3980-5537',
  storeinfo_contact_note: '（定休日を除く）',
  storeinfo_reservation: 'ご予約はこちら',

  // Reservation
  reservation_label: 'RESERVATION',
  reservation_title: 'ご予約',
  reservation_subtitle: 'ご予約は、お電話にて承っております。',
  reservation_phone_title: 'ご予約お電話にて',
  reservation_phone: '03-3980-5537',
  reservation_phone_note: '（定休日を除く）',
  reservation_note: 'ご予約の際は、以下の情報をお伝えください。',
  reservation_tag_date: 'ご希望日時',
  reservation_tag_people: '人数',
  reservation_tag_allergy: 'アレルギー',

  // Footer
  footer_nav_title: 'NAVIGATION',
  footer_nav_home: 'HOME',
  footer_nav_menu: 'お品書き',
  footer_nav_about: 'こだわり',
  footer_nav_access: '店舗情報',
  footer_nav_reservation: 'ご予約',
  footer_info_title: 'INFO',
  footer_address: '〒171-0022\n東京都豊島区南池袋２丁目９−１８',
  footer_tel: 'Tel. 03-3980-5537',
  footer_hours_lunch: '【昼】11:30 - 14:00 (L.O. 13:30)',
  footer_hours_dinner: '【夜】17:00 - 22:00 (L.O. 21:30)',
  footer_closed: '定休日：月曜日',
  footer_copyright: '© {{year}} 貴寿司. All Rights Reserved.',
};